<template>
    <div class="equity-common-content">
        <div class="e-common-frames">
            <div class="e-top e-common-block">
                <div class="e-common-lr">
                    <div class="e-left">
                          <img src="@/assets/images/e-tjx-gdjd-icon@2x.png" alt="">
                    </div>
                    <div class="e-right">
                        <h3>高端酒店入住权益</h3>
                        <p>全年2间夜高端酒店入住权益,酒店覆盖境内几十个热门旅游度假城市,近百家星级、精品酒店。</p>
                    </div>
                </div>
            </div>
            <div class="e-bottom e-common-block">
                <h2>温馨提示</h2>
                <p class="bold">细则1</p>
                <p>每人全年2间夜高端酒店入住权益</p>
                <p class="bold">细则2</p>
                <p>本行将在您激活人民币卡3个工作日内,为您开通高端酒店入住权益。</p>
                <p class="bold">细则3</p>
                <p>高端酒店入住权益仅限持卡人本人预定,且入住人必须为持卡人本人,本权益不可转让他人使用。</p>
                <p class="bold">细则4</p>
                <p>您至少需提前7个工作日在信用卡微信公众号权益平台预定入住酒店及入住日期,仅接受距离入住日起2个月内的预定。</p>
                <p class="bold">细则5</p>
                <p>本权益不适用于国家法定节假日(含调休假)及前夜期间：元旦长假及前夜、农历春节长假及前夜、清明节长假及前夜、劳动节长假 及前夜、端午节长假及前夜、中秋节长假及前夜、国庆节长假及前夜、圣诞节12月24日-12月26日、12月31日。当地展会高峰期间不接受预定。其他不适用时间,具体因酒店而有所不同,请以订单确认为准。</p>
                <p class="bold">细则6</p>
                <p>成功提交预订申请后,供应商将在一个工作日内为您联系酒店进行预订,确认预定成功后,供应商将发送预定确认成功短信至您预留的手机号；一旦预定成功恕不接受任何形式的取消或变更,若无法在预定时间入住,我行视为您已使用本权益,并扣减相应权益次数。</p>
                <p class="bold">细则7</p>
                <p>预定成功后,供应商将为您预留的手机号发送预定确认成功短信;一旦预定成功恕不接受任何形式的取消或变更,若无法在预定时间入住,我行视为您已使用本权益,并扣减相应权益次数。</p>
                <p class="bold">细则8</p>
                <p>所有酒店房型一次可入住2人,已包括房费、相应人数的早餐费用和税费等相关费用。此外其他任意消费均需按实际入住酒店收费标准另行支付。</p>
                <p class="bold">细则9</p>
                <p>高端酒店入住权益所提供的酒店信息(包括参与活动的酒店、房型、不适用日期等)将不定期更新或调整,请以我行信用卡权益平台服务预订显示为准。</p>
            </div>
            <div class="banner-detail-btn" @click="gdjdPush"><img src="@/assets/images/tjx/banner_tjx_gdjd.jpg" alt=""></div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            gdjdPush() {
                this.$test('tjx gdjd-banner')
                // console.log('钛金鑫卡高端酒店入住')
                this.$router.push('/servicetable/gdjd')
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>